/**
 * @generated SignedSource<<9785f75878670111f4f064b2e09ddd6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostVoteType = "DOWN" | "NONE" | "UP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type commentPreviewFragment$data = {
  readonly __typename: string;
  readonly author: {
    readonly avatarFallback: string;
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly photo: {
      readonly signedUrl: string;
    } | null | undefined;
  } | null | undefined;
  readonly content: any | null | undefined;
  readonly event?: {
    readonly slug: string;
    readonly title: string;
  };
  readonly id: string;
  readonly post?: {
    readonly slug: string;
    readonly space: {
      readonly slug: string;
    } | null | undefined;
    readonly title: string;
  };
  readonly userVote: {
    readonly vote: PostVoteType;
  } | null | undefined;
  readonly votes: number;
  readonly " $fragmentType": "commentPreviewFragment";
};
export type commentPreviewFragment$key = {
  readonly " $data"?: commentPreviewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentPreviewFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "commentPreviewFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarFallback",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "signedUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentVote",
      "kind": "LinkedField",
      "name": "userVote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vote",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Post",
          "kind": "LinkedField",
          "name": "post",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "EventComment",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "CommentInterface",
  "abstractKey": "__isCommentInterface"
};
})();

(node as any).hash = "56c9deaf9ffbc366245ec6f7b3a5ce3f";

export default node;
